import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import {
  getRequest,
  loadSessionUser,
  patchRequest,
  postRequest,
} from "../../Services/axios.service";
import { CHANGEPASSWORD, CLIENT_INFO, GETUSER } from "../../Utils/url.api";
import { useNavigate } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import InputMask from "react-input-mask";
import useUser from "../../Context/hook/useUser";
import { normalizePhone } from "../../Utils/normalize";
import { toast, ToastContainer } from "react-toastify";

export const User = () => {
  const { getUser } = useUser();
  const navigate = useNavigate();
  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm({ mode: "onChange" });

  const [user, setUser] = useState(null);
  const [contentEditable, setContentEditable] = useState(null);

  useEffect(() => {
    fetchUser();
  }, []);

  const fetchUser = async () => {
    const headers = {
      Authorization: `Bearer ${loadSessionUser()}`,
    };
    const { data } = await getRequest(GETUSER, { headers });
    if (data?.statusCode === 200) {
      setUser((current) => data?.data);
      reset({ phoneNumber: data?.data?.phoneNumber });
    }
  };

  const onChangeContentEditable = (val) => {
    reset({ phoneNumber: user?.phoneNumber });
    setContentEditable(val);
  };

  const submitChanges = async (formValue) => {
    const headers = {
      Authorization: `Bearer ${loadSessionUser()}`,
    };
    const patchModel = [
      {
        path: `/phoneNumber`,
        op: "replace",
        value: normalizePhone(formValue?.phoneNumber).toString(),
      },
    ];

    toast
      .promise(
        patchRequest(CLIENT_INFO, getUser()?.id, patchModel, { headers }),
        {
          pending: {
            position: "top-center",
            type: "default",
            isLoading: true,
            icon: false,
            render: () => "Espere",
          },
        }
      )
      .then(({ data }) => {
        if (data.statusCode === 200) {
          toast.success("¡El teléfono ha sido modificado!");
          fetchUser();
        } else {
          toast.error(
            `No se pudo cambiar el numero de teléfono \n error: ${
              data?.message ?? ""
            }`
          );
        }
        setContentEditable((cur) => null);
      })
      .catch((err) => {
        toast.error(
          `Ha ocurrido un error tratando de cambiar el teléfono error: ${
            err?.message ?? ""
          }`
        );
        setContentEditable((cur) => null);
      })
      .finally(() => setContentEditable((cur) => null));
  };

  return (
    <div className="w-2/4 mx-auto py-24 text-xl">
      <ToastContainer />
      <div className="">
        <h2 className="text-4xl text-font-muted font-bold">
          Información Personal
        </h2>
      </div>
      <div className="flex flex-col justify-center gap-y-4 mt-16">
        <div className="">
          <p className="text-xl text-dark">Nombre Completo</p>
          <p className="text-lg text-font-disabled">{user?.fullName}</p>
        </div>
        <hr className="my-8 border-bd-light"></hr>
        <div className="">
          <p className="text-xl text-dark">Correo Electrónico </p>
          <p className="text-lg text-font-disabled">{user?.email}</p>
        </div>
        <hr className="my-8 border-bd-light"></hr>
        <div className="">
          <p className="text-xl text-dark">Identificación</p>
          <p className="text-lg text-font-disabled">{user?.documentNumber}</p>
        </div>
        <hr className="my-8 border-bd-light"></hr>
        <div className="">
          <div className="flex justify-between">
            <div className="">
              <p className="text-xl text-dark">Número de Teléfono</p>
              <p
                className="text-lg text-font-disabled"
                hidden={contentEditable === "phoneNumber"}
              >
                {user?.phoneNumber}
              </p>
              {contentEditable === "phoneNumber" && (
                <>
                  <Controller
                    name="phoneNumber"
                    control={control}
                    defaultValue={user?.phoneNumber}
                    rules={{
                      required: {
                        message: "El número de teléfono no puede estar vacio",
                        value: true,
                      },
                    }}
                    render={({ field: { onChange, value, ref, onBlur } }) => (
                      <InputMask
                        className="custom-form__input mt-4"
                        onChange={onChange}
                        onBlur={onBlur}
                        inputRef={ref}
                        mask="999-999-9999"
                        maskChar=""
                        value={value ?? ""}
                      ></InputMask>
                    )}
                  ></Controller>
                  {errors.phoneNumber?.type === "required" && (
                    <p className="text-danger" role="alert">
                      {errors.phoneNumber?.message}
                    </p>
                  )}
                  <div className="gap-x-8 mt-4 flex items-start">
                    <button
                      className="text-primary rounded-lg"
                      onClick={handleSubmit(submitChanges)}
                    >
                      Guardar
                    </button>
                    <button
                      className="text-warning rounded-lg"
                      onClick={() => onChangeContentEditable(null)}
                    >
                      Cancelar
                    </button>
                  </div>
                </>
              )}
            </div>
            <a
              className="link cursor-pointer"
              hidden={contentEditable === "phoneNumber"}
              onClick={() => onChangeContentEditable("phoneNumber")}
            >
              Editar
            </a>
          </div>
        </div>
        <hr className="my-8 border-bd-light"></hr>
        <div className="">
          <p className="text-xl text-dark">Nacionalidad</p>
          <p className="text-lg text-font-disabled">
            {user?.nationality?.description ?? "-"}
          </p>
        </div>
        <hr className="my-8 border-bd-light"></hr>
        <div className="">
          <p className="text-xl text-dark">Tipo de usuario</p>
          <p className="text-lg text-font-disabled">
            {user?.clientType?.identificator == "C"
              ? "Local"
              : user?.clientType?.identificator == "PP"
              ? "Extranjero"
              : user?.clientType?.identificator == "TO"
              ? "Tour Operador"
              : "-"}
          </p>
        </div>
        <hr className="my-8 border-bd-light"></hr>
        {!user?.signWithGoogle && (
          <div>
            <div className="flex justify-between">
              <p className="text-xl text-dark">Cambiar contraseña</p>
              <a
                className="link cursor-pointer"
                onClick={() => navigate("/user/reset-password")}
              >
                Editar
              </a>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
